import { FontAwesomeIcon } from '@hivebrite/design-system/FontAwesomeIcon';

const CopyLink = () => <FontAwesomeIcon height="16px" iconName="copy" />;
const ArrowUpRight = () => (
  <FontAwesomeIcon height="16px" iconName="arrow-up-right-from-square" />
);
const Download = () => <FontAwesomeIcon height="16px" iconName="download" />;

export const actionItemsIcons = {
  arrowUpRight: ArrowUpRight,
  copyLink: CopyLink,
  download: Download,
};
